import firebase from 'firebase/app'
// eslint-disable-next-line
import firestore from 'firebase/firestore'

// Initialize Firebase
var config = {
  apiKey: 'AIzaSyDm7QdnDUQ_Ba-CmyfQEPjKz3p8eo3GIaE',
  authDomain: 'trello-copy.firebaseapp.com',
  databaseURL: 'https://trello-copy.firebaseio.com',
  projectId: 'trello-copy',
  storageBucket: 'trello-copy.appspot.com',
  messagingSenderId: '904331054406'
}
firebase.initializeApp(config)
const db = firebase.firestore()

export default db
